import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { DialogResult } from '../../../models/modal-dialog-result';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [],
  templateUrl: './confirm-delete-modal.component.html',
  styleUrl: './confirm-delete-modal.component.scss'
})
export class ConfirmDeleteModalComponent {
  @Input() title: string = 'Delete?';
  @Input() message: string = 'Are you sure you want to delete?';

  public onClose: Subject<DialogResult> = new Subject();

  constructor(public activeModal: NgbActiveModal) {
  }

  ok() {
    this.onClose.next({ result: true });
    this.activeModal.dismiss();
  }

  cancel() {
    this.onClose.next({ result: false });
    this.activeModal.dismiss();
  }
}
